import axios from "axios";
import { toast } from "sonner";

const adminApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL || ""}/api/admin`,
  withCredentials: true,
});

let refreshing = null;

adminApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config || {};
    const url = original.url || "";
    if (error.response?.status === 401 && !original._retried && !url.includes("/auth/")) {
      original._retried = true;
      try {
        refreshing = refreshing || adminApi.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return adminApi(original);
      } catch {
        // refresh échoué — le caller reçoit le 401
      }
    }
    // erreurs non gérées localement (5xx / réseau) : remontée visible à l'opérateur
    if ((!error.response || error.response.status >= 500) && !url.includes("/auth/")) {
      toast.error("Une erreur est survenue", { description: "L'opération n'a pas abouti. Réessayez." });
    }
    return Promise.reject(error);
  }
);

export const apiError = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail)) {
    const msg = detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
    return msg || fallback;
  }
  return fallback;
};

export default adminApi;
